import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { BillingAddress, ButtonParams, DCFCheckoutParams, DpaData, SrciInitParamsVisa, SrciInitParamsMastercard, SRCiInputData, TransactionAmount } from "../../models/SRCiInputData"
import { GeneralInputs } from "../../models/GeneralInputs"
import set from "lodash/set"
import { SrciMastercardCustomInputData } from "@payair/srci-sdk/models/SrciMastercardCustomInputData"
import { ConsumerPrefillScenario, getConsumerPrefill } from "../../data/SrciConsumerPrefills"

const generalInput: GeneralInputs = {
  currencyCode: "SEK",
  totalAmount: "1.99",
  totalAmountLabel: "Demo purchase",
  merchantName: "Payair test merchant",
  merchantId: "test.merchant.ape",
  payairUrl: "https://dev.googlepayecom.payair.com",
  transactionId: "0a4e0d316891e3080a3750ab8ba51cd0d64365ad35dc60c",
  environment: "QA",
  pspName: "qa-payair",
  locale: "en_GB"
}

const billingAddress: BillingAddress = {
  name: "",
  line1: "",
  line2: "",
  line3: "",
  city: "",
  state: "",
  countryCode: "SE",
  zip: ""
}

const srcTransactionAmount: TransactionAmount = {
  transactionAmount: 750,
  transactionCurrencyCode: generalInput.currencyCode,
};

const srciInitVisa: SrciInitParamsVisa = {
  srcInitiatorId: "K5IJSR4T7QGDX4POXQWT21F1U9wQW2_s-82xGpOSK9mzH8FkY",
  srciDpaId: "ac1b9e36-cce5-4204-9bbd-2475a9f904ef",
  srciTransactionId: "6e16736a-bd2d-4056-bc9c-6f217d31aa0e",
  dpaTransactionOptions: {
    dpaAcceptedBillingCountries: ["SE","PL"],
    dpaAcceptedShippingCountries: ["SE","PL"],
    dpaBillingPreference: "NONE",
    dpaShippingPreference: "NONE",
    dpaLocale: "en_GB",
    consumerNameRequested: true,
    consumerEmailAddressRequested: true,
    consumerPhoneNumberRequested: true,
    transactionType: "PURCHASE",
    transactionAmount: srcTransactionAmount,
    reviewAction: undefined,
    checkoutDescription: undefined,
    orderType: undefined,
    payloadTypeIndicator: "FULL",
    merchantOrderId: undefined,
    merchantCategoryCode: undefined,
    merchantCountryCode: undefined,
    threeDSInputData: undefined
  },
  pspName: "qa-payair"
}

const customDataInput: SrciMastercardCustomInputData = {
  "com.mastercard.dcfExperience": "PAYMENT_SETTINGS"
}

const srciInitMastercard: SrciInitParamsMastercard = {
  srcInitiatorId: "7ecf0496-b303-4c5a-9692-eff5daee5ab9",
  srciDpaId: "a2136475-eab9-4161-8c88-1a0b3f5f7ca0",
  srciTransactionId: "6e16736a-bd2d-4056-bc9c-6f217d31aa0e",
  dpaTransactionOptions: {
    dpaAcceptedBillingCountries: ["SE","PL"],
    dpaAcceptedShippingCountries: ["SE","PL"],
    dpaBillingPreference: "NONE",
    dpaShippingPreference: "NONE",
    dpaLocale: "en_GB",
    consumerNameRequested: true,
    consumerEmailAddressRequested: true,
    consumerPhoneNumberRequested: true,
    transactionType: "PURCHASE",
    transactionAmount: srcTransactionAmount,
    isGuestCheckout: false,
    customInputData: customDataInput,
    confirmPayment: true
  },
  pspName: "qa-payair"
}

const dcfCheckoutParams: DCFCheckoutParams = {
  enrollBeforeCheckout: false,
  isRecognizeddpaTransactionOptions: "Payair",
  srciActionCode: "NEW_USER",
  srciTransactionId: "6e16736a-bd2d-4056-bc9c-6f217d31aa0e",
  consumer: {
    emailAddress: "",
    firstName: "",
    lastName: "",
    mobileNumber: {
      countryCode: "",
      phoneNumber: ""
    },
    countryCode: "",
    consumerIdentity: {
      identityProvider: "SRC",
      identityType: "EMAIL_ADDRESS",
      identityValue: ""
    }
  },
  dpaTransactionOptions: {
    dpaAcceptedBillingCountries: ["PL", "SE"],
    dpaAcceptedShippingCountries: ["PL", "SE"],
    dpaBillingPreference: "FULL",
    dpaShippingPreference: "NONE",
    dpaLocale: "en_GB",
    consumerNameRequested: true,
    consumerEmailAddressRequested: true,
    consumerPhoneNumberRequested: true,
    transactionType: "PURCHASE",
    transactionAmount: srcTransactionAmount,
    isGuestCheckout: false,
  }
}

const buttonParams: ButtonParams = {
  locale: "en_gb",
  buttonsize: "big",
  paymentmethod: "master"
}

const dpaData: DpaData = {
  dpaPresentationName: "Payair",
  dpaUri: "https://www.payair.com"
}

const srciInputData: SRCiInputData = {
  generalInput: generalInput,
  billingAddress: billingAddress,
  srciInitVisa: srciInitVisa,
  srciInitMastercard: srciInitMastercard,
  dcfCheckoutParams: dcfCheckoutParams,
  buttonParams: buttonParams,
  dpaData: dpaData,
  requestedValidationChannelId: "EMAIL_ADDRESS"
}

export const saveToStorage = (state: any, action: any) => {
  const payload = action.payload
  const name = payload.name
  const value = payload.value

  return set(state, name, value)
}

export const srciInputDataReducer = createSlice({
  name: 'srciInputData',
  initialState: srciInputData,
  reducers: { 
    save: (state, action) => {
      saveToStorage(state, action)
    },
    loadConsumerPrefill: (state, action: PayloadAction<ConsumerPrefillScenario>) => {
      state.dcfCheckoutParams.consumer = getConsumerPrefill(action.payload)
    }
  }
})

const { actions, reducer } = srciInputDataReducer
export const { loadConsumerPrefill, save } = actions
export default reducer
